
<gw-page-header>
  <ng-container page-header-left="page-header-left">
    <ul class="header__menu header__menu--left">
      <li class="header__item"><a class="button button--link header__button--transparent header__button--menu" (click)="auditNavigationService.toggleNavigation()"><i class="gw-hamburger button__icon"></i></a></li>
      <li class="header__item header__item--title">{{ 'DASHBOARD.PAGE_HEADER' | translate }}</li>
    </ul>
  </ng-container>
</gw-page-header>